export const environment = {
    production: false,
    keycloakBaseUrl: 'https://sso.preprod.services.utimaco.com',
    keycloakRealm: 'Utimaco-Portal-PREPROD',
    keycloakClientId: 'TaasTsFrontend',
    userManagementRestApiBasePath: 'https://sm-api.preprod.services.utimaco.com/taas/sm/api/',
    taasPortalFrontendUrl: 'https://portal.preprod.services.utimaco.com',
    timestampBackendRestApiUrl: 'https://tsaas-api.preprod.services.utimaco.com/api/v1/'
};